<template>
  <div class="block">
    <name-input
      v-if="currentStage === 'name'"
      :user="users"
      :startedField="'startedMemory'"
      @idChanged="lookupComp"
      @startCountdown="startCountdown"
    />
    <countdown v-if="currentStage === 'countdown'" @startGame="startGame" />
    <puzzle
      v-if="currentStage === 'puzzle' && showingMap"
      :key="puzzleNumber"
      :number="Math.round(puzzleNumber / 2)"
      :name="
        `https://brownben.github.io/images/memory/comp/n${puzzleNumber}.jpg`
      "
      :options="options"
      :keyboard="false"
      :countdown="false"
      :hideSkip="showingMap"
      @complete="puzzleComplete"
    />
    <puzzle-tall
      v-if="currentStage === 'puzzle' && !showingMap"
      :key="puzzleNumber"
      :number="Math.round(puzzleNumber / 2)"
      :name="
        `https://brownben.github.io/images/memory/comp/n${puzzleNumber}.jpg`
      "
      :options="options"
      :keyboard="false"
      :countdown="false"
      :hideSkip="showingMap"
      @complete="puzzleComplete"
    />
    <pause v-if="currentStage === 'pause'" @nextPuzzle="nextPuzzle" />
    <game-over
      v-if="currentStage === 'gameover'"
      :user="user.name"
      :time="userTime"
      :score="userScore"
      :error="error"
    />
  </div>
</template>

<script>
import NameInput from '@/components/NameInput'
import Countdown from '@/components/Countdown'
import Puzzle from '@/components/PuzzleSmall'
import PuzzleTall from '@/components/PuzzleTall'
import Pause from '@/components/Pause'
import GameOver from '@/components/GameOver'

import firebase from 'firebase/app'
import 'firebase/firestore'

const db = firebase.firestore()

export default {
  components: {
    NameInput,
    Countdown,
    Puzzle,
    PuzzleTall,
    Pause,
    GameOver,
  },

  data: function() {
    return {
      puzzleNumber: 1,
      currentStage: 'name',
      choices: [],
      times: [],
      userScore: '',
      userScoreNumber: 0,
      userTime: 0,
      solution: ['B', 'C', 'D', 'A', 'C', 'B', 'A', 'A', 'D', 'A'],
      users: {},
      user: {},
      error: 1,
    }
  },

  computed: {
    lastLegCorrect: function() {
      return (
        this.solution[Math.round(this.puzzleNumber / 2) - 1] ===
        this.choices[Math.round(this.puzzleNumber / 2) - 1]
      )
    },

    options: function() {
      if (this.puzzleNumber % 2 === 0) return ['A', 'B', 'C', 'D']
      else return ['Go']
    },

    showingMap: function() {
      return this.puzzleNumber % 2 === 1
    },
  },

  methods: {
    lookupComp: async function(id) {
      try {
        if (this.currentStage === 'name')
          this.users = await db
            .collection('teams')
            .doc(id.toString())
            .get()
            .then(result => ({ id, ...result?.data() }))
      } catch (error) {
        this.users = {}
      }
    },

    startCountdown: function(user) {
      this.user = user
      this.setUserStarted(user.id)
      this.currentStage = 'countdown'
    },

    setUserStarted: function(userId) {
      return db
        .collection('teams')
        .doc(userId.toString())
        .update({ startedMemory: true, device: navigator.userAgent })
    },

    saveUserResult: function() {
      return Promise.all([
        this.saveToMainDatabase({
          id: parseInt(this.user.id, 10),
          username: this.user.name.trim(),
          score: this.userScore.toString(),
          time: (this.userTime / 1000).toFixed(2).toString(),
        }),

        db
          .collection('teams')
          .doc(this.user.id.toString())
          .update({
            memoryChoices: this.choices,
            memoryTimes: this.times,
            memoryTime: this.userTime,
          }),
      ])
        .then(() => {
          this.error = 0
        })
        .catch(err => {
          console.log(err)
          this.error = 2
        })
    },

    saveToMainDatabase: function(result) {
      return Promise.resolve()
    },

    startGame: function() {
      this.currentStage = 'puzzle'

      if (this.puzzleNumber >= this.solution.length * 2) {
        this.currentStage = 'gameover'

        this.userScore = this.scoreUser()
        this.userTime = this.times.reduce((a, b) => a + b, 0)
      }
    },

    puzzleComplete: function(result) {
      if (this.puzzleNumber % 2 === 0) {
        this.choices.push(result.choice)
        this.times.push(result.time)

        if (this.puzzleNumber !== this.solution.length * 2)
          this.currentStage = 'pause'
        else this.nextPuzzle()
      } else {
        this.times.push(result.time)
        this.puzzleNumber += 1
      }
    },

    nextPuzzle: function() {
      if (this.puzzleNumber >= this.solution.length * 2) {
        this.currentStage = 'gameover'

        this.userScore = this.scoreUser()
        this.userTime = this.times.reduce((a, b) => a + b, 0)
        this.saveUserResult()
      } else {
        this.puzzleNumber += 1
        this.currentStage = 'puzzle'
      }
    },

    scoreUser: function() {
      let correct = 0
      let i = 0

      while (i < this.choices.length) {
        if (this.solution[i] === this.choices[i]) correct += 1
        i += 1
      }

      this.userScoreNumber = correct
      return `${correct}`
    },
  },
}
</script>
